// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#overlapsContainer > * {\n  padding: 0;\n}\n#overlapsTitle.v-expansion-panel-header {\n  padding-left: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
